var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightForBreadcrumbs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m14.83 12.425-3.292 3.399a.566.566 0 0 1-.82 0l-.547-.565a.61.61 0 0 1 0-.847l2.333-2.41-2.333-2.409a.61.61 0 0 1 0-.847l.544-.57a.566.566 0 0 1 .82 0l3.292 3.4c.23.234.23.614.003.849"
})));
export default SvgArrowRightForBreadcrumbs;